<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="http://www.shapelog.com/">
        <img src="../assets/shapelog-logo.svg"
          alt="ShapeLog: a better strength training experience" width="112" height="28">
      </a>
    </div>
    <div class="navbar-end">
      <div class="navbar-item">
        <div class="field is-grouped">
          <p class="control" v-if="!isRoot">
            <a class="button is-primary" v-on:click="logOut">
              Log Out
            </a>
          </p>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      sharedStore: this.$root.store,
      current: window.location.pathname,
    };
  },
  computed: {
    isRoot() {
      return (this.current === '/');
    },
  },
  methods: {
    logOut() {
      this.sharedStore.clearToken();
      window.location.href = '/';
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../styles/common.scss';
  nav {
    display: flex;
    align-items: stretch;
  }
  .navbar {
    background-color: $shape-log-dark-gray;
  }
  .navbar-end {
    align-items: stretch;
    justify-content: flex-end;
    margin-left: auto;
  }
  .navbar-brand {
    a {
      color: $white;
    }
  }
</style>
